export enum AnalyticsEvent {
  FreeListingContractAcceptTermsAndConditionsClicked = 'freeListingContractAcceptTermsAndConditionsClicked',
  FreeListingContractChooseAnotherAdPackageClicked = 'freeListingContractChooseAnotherAdPackageClicked',
  FreeListingContractPageViewed = 'freeListingContractPageViewed',
  FreeToPaidUpsellPromptCancelled = 'Free_Prompt_Cancelled',
  FreeToPaidUpsellPromptFreeSelected = 'Free_Prompt_Freemium_Selected',
  FreeToPaidUpsellPromptPaidSelected = 'Free_Prompt_Paid_Selected',
  RecommendationRelevantNo = 'recommendationRelevantNo',
  RecommendationRelevantYes = 'recommendationRelevantYes',
  UpgradeContractRequestViewed = 'upgradeContractRequestViewed',
  UpgradeContractRequested = 'upgradeContractRequested',
  UpgradeContractRequestConfirmation = 'upgradeContractRequestConfirmation',
  UserLogin = 'userLogin',
  UserLoaded = 'userLoaded',
}
